import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  OnChanges,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DateFieldComponent),
  multi: true
};

@Component({
  selector: 'date-field',
  inputs: [...AbstractField.inputs, 'minDate', 'maxDate', 'frequency'],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="change($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        type="text"
        [markDisabled]="disabledDays"
        [minDate]="minDate"
        [maxDate]="maxDate"
        ngbDatepicker
        #sd="ngbDatepicker"
        (click)="sd.toggle()"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class DateFieldComponent extends AbstractField implements OnChanges {
  minDate;
  maxDate;
  frequency;
  disabledDays;
  @ViewChild('sd', { static: true }) sd;
  @Output() update = new EventEmitter();
  constructor() {
    super();
    const _today = new Date();
    if (this.frequency === 'twicemonthly') {
      this.setDates();
    }
  }
  setDates(reset = false) {
    let days = [
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31
    ];
    if (reset) {
      days = [];
    }
    this.disabledDays = (date: any, current: { month: number }) =>
      days.indexOf(date.day) >= 0;
  }
  change($event) {
    this.update.emit($event);
  }
  ngOnChanges(changes) {
    this.sd.close();
    // if twicemonthly set then limit the dates to 1st and 15th
    if (
      (changes.frequency &&
        changes.frequency.currentValue === 'twicemonthly') ||
      (changes.minDate && this.frequency === 'twicemonthly')
    ) {
      this.setDates();
    } else {
      this.setDates(true);
    }
  }
}
